<template>
  <div v-if="isVisible" class="maac-modal-overlay" @click.self="close">
    <div class="maac-modal-container">
      <div class="maac-modal-close" @click="close">&times;</div>
      <h2 class="maac-modal-title">透過 LINE 預約，方便又可收到 LINE 診前提醒！</h2>

      <div class="maac-modal-content">
        <!-- 舊戶 Column -->
        <div class="maac-modal-column">
          <h3 class="maac-modal-subtitle">舊戶</h3>
          <div class="maac-modal-card">
            <p class="maac-modal-text">
              推薦掃描以下 QR code，在 LINE 官方帳號內預約，可記憶本人及家屬基本資料，每次掛號不必重複輸入，還可收到 LINE 通知提醒就診服務，預約快速又不怕忘記！
            </p>
            <div class="maac-modal-qr-container">
              <div v-if="isLoadingQrCode" class="maac-modal-qr-loader">
                <div class="spinner"></div>
              </div>
              <vue-qr v-else :text="qrCodeText" :size="120" />
            </div>
          </div>
        </div>

        <!-- 新戶 Column -->
        <div class="maac-modal-column">
          <h3 class="maac-modal-subtitle">新戶</h3>
          <div class="maac-modal-card">
            <p class="maac-modal-text">
              若未曾在本院所就醫，您目前無法使用 LINE 通知提醒就診服務。
            </p>
            <p class="maac-modal-text mt-4">
              請您先在網頁版完成本次掛號。首次就醫後即可啟用 LINE 會員服務。
            </p>
          </div>
          <button class="maac-modal-button" @click="handleNewUserClick">我知道了</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr';

export default {
  name: 'MaacModal',
  components: {
    vueQr
  },
  props: {
    qrCodeText: {
      type: String,
      default: ''
    },
    isLoadingQrCode: {
      type: Boolean,
      default: false
    },
    redirectUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isVisible: false
    };
  },
  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
    },
    handleNewUserClick() {
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl;
      }
      this.close();
    }
  }
};
</script>

<style scoped>
.maac-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.maac-modal-container {
  background: #C3CED5;
  width: 95%;
  max-width: 640px;
  padding: 40px 20px 30px;
  border-radius: 8px;
  position: relative;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.maac-modal-close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 28px;
  cursor: pointer;
  color: #555;
  line-height: 1;
}

.maac-modal-title {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 32px;
  color: #333;
  padding: 0 10px;
}

.maac-modal-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr auto; /* Rows: Subtitle, Card, Button */
  gap: 0 16px;
}

.maac-modal-column {
  display: grid;
  grid-template-rows: subgrid;
  grid-row: span 3;
  width: 100%;
}

.maac-modal-subtitle {
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.maac-modal-card {
  background: white;
  padding: 15px;
  border-radius: 4px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 250px;
}

.maac-modal-text {
  font-size: 0.9rem;
  line-height: 1.5;
  text-align: left;
  color: #444;
}

.maac-modal-qr-container {
  margin-top: auto;
  display: flex;
  justify-content: center;
  padding-top: 15px;
  min-height: 120px;
}

.maac-modal-qr-loader {
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  border-radius: 4px;
}

.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #1B6953;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.maac-modal-button {
  margin-top: 20px;
  margin-right: auto;
  margin-left: auto;
  background: #1B6953;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  width: 80%;
}

.mt-4 {
  margin-top: 16px;
}

@media (max-width: 576px) {
  .maac-modal-content {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto 1fr auto); /* Separate rows for each column on mobile */
  }

  .maac-modal-column {
    grid-row: span 3;
    grid-template-rows: subgrid;
  }
  .maac-modal-card {
    min-height: auto;
  }
}
</style>
